const colors = {
  DarkGray: 'rgb(0, 0, 0, 0.85)',
  Gray: 'rgb(0, 0, 0, 0.65)',
  LightGray: 'rgb(0, 0, 0, 0.45)',
  LighterGray: 'rgb(0, 0, 0, 0.25)',
  EvenLighterGray: 'rgb(0, 0, 0, 0.15)',
  LightestGray: 'rgb(0, 0, 0, 0.05)',
  Primary: '#13ad87',
  Secondary: '#fa541c',
  GreenHighlight: '#d8ede4',
};

module.exports = colors;
